module.exports = __webpack_public_path__ + "static/img/OLIVER_JEFFERS.5d152ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/OLIVER_JEFFERS.jpg
// module id = X1wz
// module chunks = 1